import { ContextDataPageTypeEnum } from '@redteclab/api/clients/adserver-api'

import { type ExperimentType } from '../experiments/model/Experiment.types'

import { AD_SERVER_EXPERIMENTS_PREFIX } from './adServerConst'

export const adServerGetExperiments = (
  experiments: ExperimentType[],
  pageType: ContextDataPageTypeEnum,
): ExperimentType[] =>
  experiments.filter(({ isEnabled, name }) => {
    if (!isEnabled || !name.startsWith(AD_SERVER_EXPERIMENTS_PREFIX)) {
      return false
    }

    /**
     * Remove ad server experiment prefix from the name and
     * create parts from the rest
     * global experiment:
     * name of the experiment in optimizely ad-exp-{experimentName/ticketName}
     * e.g.: ad-exp-top-banner -> ['top', 'banner']
     * page type oriented experiment:
     * name of the experiment in optimizely ad-exp-{pageType}-{experimentName/ticketName}
     * e.g: ad-exp-product-xsell -> ['product', 'xsell']
     * name in ad server targeting: {experimentName/ticketName}_{experimentVariant}
     * more details can be found here: https://wiki.shop-apotheke.com/pages/viewpage.action?pageId=335087751
     */
    const [firstPart, ...otherParts] = name
      .slice(AD_SERVER_EXPERIMENTS_PREFIX.length)
      .split('-')
    /**
     * Checks if the first part contains valid page type
     */
    const isPageType = Object.values(ContextDataPageTypeEnum).includes(
      firstPart as ContextDataPageTypeEnum,
    )

    /**
     * global experiment is activated regardless the page type
     * e.g. ad-exp-xsell || ad-exp-top-banner
     */
    if (!isPageType || otherParts.length === 0) {
      return true
    }

    /**
     * experiment containing valid page type is activated only within matching page
     * e.g. ad-exp-product-top-banner
     */
    return pageType === firstPart
  })
